import { Outlet } from 'react-router-dom';

export default function MethodProviders() {
    return (
        <Outlet />
    )
}
